import PropTypes from 'prop-types';
import React from 'react';

import ArchiveLicenseStatusContainer from 'archive/components/ArchiveLicenseStatusContainer';
import { TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY } from 'stores/indices/IndicesStore';

type Props = {
  config: {
    max_number_of_indices: number,
    index_action: string,
  },
  rotationStrategyClass?: string
};

const ArchiveRetentionStrategySummary = ({ config: { index_action, max_number_of_indices }, rotationStrategyClass }: Props) => (
  <div>
    <dl>
      <dt>Index retention strategy:</dt>
      <dd>Archive</dd>
      {rotationStrategyClass !== TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY && (
      <>
        <dt>Max number of indices:</dt>
        <dd>{max_number_of_indices}</dd>
      </>
      )}
      <dt>Index action:</dt>
      <dd>{index_action}</dd>
    </dl>
    <ArchiveLicenseStatusContainer summary />
  </div>
);

ArchiveRetentionStrategySummary.propTypes = {
  config: PropTypes.shape({
    max_number_of_indices: PropTypes.number.isRequired,
    index_action: PropTypes.string.isRequired,
  }).isRequired,
  rotationStrategyClass: PropTypes.string,
};

ArchiveRetentionStrategySummary.defaultProps = {
  rotationStrategyClass: undefined,
};

export default ArchiveRetentionStrategySummary;
